import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import { withTranslation } from 'react-i18next';
import { TextField } from '@totalsoft/rocket-ui';
import { DateTime } from '@ts-private/rocket-extensions';

const ContractInfoComponent = ({ t, leasingOfferContractData }) => {
  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_financedValue'}
          isNumeric
          disabled
          fullWidth
          value={leasingOfferContractData.financedValue || ''}
          label={t('RestructuringEdit.Contract.FinancedValue')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_amountWithoutVAT'}
          isNumeric
          disabled
          fullWidth
          value={leasingOfferContractData.totalAmountWithoutVAT || ''}
          label={t('RestructuringEdit.Contract.AmountWithoutVAT')}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_advance'}
          isNumeric
          fullWidth
          value={leasingOfferContractData.advance}
          label={t('RestructuringEdit.Contract.Advance')}
          disabled
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_advancePercent'}
          isNumeric
          disabled
          fullWidth
          value={leasingOfferContractData.advancePercent}
          label={t('RestructuringEdit.Contract.AdvancePercent')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_residualValue'}
          isNumeric
          disabled
          fullWidth
          value={leasingOfferContractData.residualValue || ''}
          label={t('RestructuringEdit.Contract.ResidualValue')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_residualValuePercent'}
          isNumeric
          disabled
          fullWidth
          value={leasingOfferContractData.residualValuePercent || ''}
          label={t('RestructuringEdit.Contract.ResidualValuePercent')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_currency'}
          disabled
          fullWidth
          value={leasingOfferContractData.currencyName || ''}
          label={t('RestructuringEdit.Contract.Currency')}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_monthsNo'}
          isNumeric
          fullWidth
          value={leasingOfferContractData.monthNo || ''}
          label={t('RestructuringEdit.Contract.InstallmentNo')}
          disabled={true}
          inputProps={{ decimalScale: 0 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_periodicity'}
          fullWidth
          value={leasingOfferContractData.periodicity || ''}
          label={t('RestructuringEdit.Contract.Periodicity')}
          disabled={true}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_duration'}
          isNumeric
          fullWidth
          value={leasingOfferContractData.duration || ''}
          label={t('RestructuringEdit.Contract.Duration')}
          disabled={true}
          inputProps={{ decimalScale: 0 }}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3} id={'contractCard_startDate'}>
        <DateTime
          fullWidth
          value={leasingOfferContractData.startDate}
          label={t('RestructuringEdit.Contract.StartDate')}
          timeFormat={false}
          disabled={true}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3} id={'contractCard_endDate'}>
        <DateTime
          fullWidth
          value={leasingOfferContractData.endDate}
          label={t('RestructuringEdit.Contract.EndDate')}
          timeFormat={false}
          disabled={true}
        />
      </Grid>

      <Grid item xs={12} sm={6} md={4} lg={3}>
        <TextField
          id={'contractCard_contractType'}
          disabled
          fullWidth
          value={leasingOfferContractData.contractType || ''}
          label={t('RestructuringEdit.Contract.ContractType')}
        />
      </Grid>
    </Grid>
  );
};

ContractInfoComponent.propTypes = {
  t: PropTypes.func.isRequired,
  leasingOfferContractData: PropTypes.object.isRequired
};

export default withTranslation()(ContractInfoComponent);
